import React, { useEffect, useState } from "react";
import ChatBot from "react-simple-chatbot";
import { api } from "../../api";
import { observer } from "mobx-react";
import Cookies from 'universal-cookie';
const cookies = new Cookies()

interface DynamicResponseProps {
  steps?: any;
  previousStep?: { id: string; value: string };
  triggerNextStep?: (param?: any) => void;
}

const DynamicResponse: React.FC<DynamicResponseProps> = ({
  previousStep,
  triggerNextStep
}) => {
  const [reply, setReply] = useState("Buscando conhecimento...");

  useEffect(() => {
    const fetchReply = async () => {
      const userMessage = previousStep?.value || "";

      console.log(cookies.get("__AI-calc"))

      try {
        // const randomReplies = [
        //   "Interessante! Me conte mais sobre isso 🤔",
        //   "Hmm, entendi! 😊",
        //   "Legal! O que mais posso fazer por você?",
        //   "Haha boa! 😂",
        //   "Isso faz sentido. Quer ajuda com mais alguma coisa?",
        //   "Entendi! Posso te mostrar um exemplo se quiser.",
        //   "Uau! Não tinha pensado nisso 😮",
        //   "Beleza, vamos continuar 💪",
        //   "Certo! Quer que eu pesquise mais sobre isso?",
        //   "Perfeito! 🚀"
        // ];

        let resp = await api.post("/api/ai/chat",{input: userMessage, calc: (cookies.get("__AI-calc") == "1" ? true : false)});

        if(resp.status == 401){
          setReply("Você precisa estar logado para utilizar o chatBot-Fipo.");
        }else if(resp.status != 200){
          setReply(resp.data.msg);

        }else{
          setReply(resp.data);

        }

        //console.log(userMessage)

        //setReply("Teste");
        // const randomIndex = Math.floor(Math.random() * randomReplies.length);
        // const chosenReply = randomReplies[randomIndex];


        setTimeout(() => { triggerNextStep?.(); }, 1000);
      } catch (error) {
        console.error(error);
        setReply("Erro ao conectar com o ChatGPT 😢");
        triggerNextStep?.();
      }

    };

    fetchReply();

  }, [previousStep, triggerNextStep]);

  return <div style={{ fontSize: 14 }}>{reply}</div>;

};

const ChatPage: React.FC = () => {
  const steps = [
    {
      id: "0",
      message: "Bem-vindo à Fipo AI! como posso ajudar hoje?",
      trigger: "2",
      delay: 4000
    },
   {
      id: '2',
      options: [
        { value: 1, label: 'Falar sobre cálculos ?', trigger: '4' },
        { value: 2, label: 'Ou conversa geral ?', trigger: '6' },
      ],
    },
    {
      id: "6",
      message: "Sobre o que deseja conversar ?",
      trigger: () => {
        cookies.set('__AI-calc', "0", { path: '/' });
        return "userInput"
      }
    },
    {
      id: "userInput",
      user: true,
      trigger: "botResponse"

    },
     {
      id: "4",
      message: "Para falarmos sobre cálculo acesse o menu lateral, clicando no ícone do FIPO canto superior esquerdo e selecione o 'Chat AI'.",
      trigger: "2"
      // trigger: () => {
      //   cookies.set('__AI-calc', "1", { path: '/' });
      //   return "5"
      // }
    },
    // {
    //   id: '5',
    //   options: [
    //     { value: "Como funciona ICMS 1152 - CESTA BASICA COMPRA DE MERCADORIA", label: 'ICMS 1152 - CESTA BASICA COMPRA DE MERCADORIA', trigger: 'botResponse' },
    //     { value: "Como funciona ICMS 1146 - ANTECIPADO NORMAL (AUTO PECAS) COMPRA DE MERCADORIA", label: 'ICMS 1146 - ANTECIPADO NORMAL (AUTO PECAS) COMPRA DE MERCADORIA', trigger: 'botResponse' },
    //     { value: "Como funciona ICMS - MEDICAMENTOS DE USO VETERINÁRIO (PET) COMPRA DE MERCADORIA", label: 'ICMS - MEDICAMENTOS DE USO VETERINÁRIO (PET) COMPRA DE MERCADORIA', trigger: 'botResponse' },
    //     { value: "Gostaria de conversar cobre calculos", label: 'Falar sobre outros cálculos', trigger: 'botResponse' },
    //   ],
    //   trigger: "userInput",
    // },
    {
      id: "botResponse",
      component: <DynamicResponse />,
      waitAction: true, // impede de seguir até chamar triggerNextStep()
      trigger: "userInput",
    },
  ];

  return (
    <ChatBot
      floating
      headerTitle="FIPO AI"
      placeholder="Digite sua mensagem..."
      steps={steps}
      botDelay={600}
      botAvatar="/images/robot.png"
    />
  );
};

export default ChatPage;
